module.exports = __webpack_public_path__ + "static/media/28@2x.b110cb14.png";